import styled from "styled-components"

const Strikethrough = styled.span`
  display: inline-block;
  position: relative;

  :before {
    content: "";
    position: absolute;
    left: -0.1em;
    right: -0.1em;
    top: 0.38em;
    bottom: 0.38em;
    background: linear-gradient(
      to left top,
      transparent 0%,
      transparent calc(50% - 0.07em),
      currentColor 50.5%,
      transparent calc(50% + 0.07em),
      transparent 100%
    );
    pointer-events: none;
  }
`

export default Strikethrough
